var _a, _b, _c, _d, _e, _f;
import { NODE_NAMES } from "../utils/nodeNameContants";
export var nodeConnectionRules = (_a = {},
    _a[NODE_NAMES.INBOUND_CALL] = {
        // "Inbound Call Node"
        allowedIncomingNodes: [],
        allowedOutgoingNodes: [NODE_NAMES.CALL_DISTRIBUTION_ROUTER, NODE_NAMES.AI_AGENT, NODE_NAMES.TIME_ROUTER],
        maxIncoming: 0,
        maxOutgoing: Infinity,
        maxOutgoingPerType: (_b = {},
            _b[NODE_NAMES.TIME_ROUTER] = Infinity,
            _b[NODE_NAMES.CALL_DISTRIBUTION_ROUTER] = 1,
            _b[NODE_NAMES.AI_AGENT] = 1,
            _b)
    },
    _a[NODE_NAMES.CALL_DISTRIBUTION_ROUTER] = {
        // "Agent Router Node"
        // 1 incoming from Inbound Call,
        // Outgoing only to Agent (AiAgentNode)
        allowedIncomingNodes: [NODE_NAMES.INBOUND_CALL, NODE_NAMES.TIME_ROUTER],
        allowedOutgoingNodes: [NODE_NAMES.AI_AGENT, NODE_NAMES.TIME_ROUTER],
        maxIncoming: 1,
        maxOutgoing: Infinity,
        maxOutgoingPerType: (_c = {},
            _c[NODE_NAMES.TIME_ROUTER] = Infinity,
            _c[NODE_NAMES.AI_AGENT] = Infinity,
            _c)
    },
    _a[NODE_NAMES.AI_AGENT] = {
        // "Agent Node" 
        // Incoming from inbound call or agent router
        // Outgoing to buyer router or buyer
        allowedIncomingNodes: [NODE_NAMES.INBOUND_CALL, NODE_NAMES.CALL_DISTRIBUTION_ROUTER, NODE_NAMES.TIME_ROUTER],
        allowedOutgoingNodes: [NODE_NAMES.BUYER_ROUTER, NODE_NAMES.BUYER, NODE_NAMES.TIME_ROUTER],
        maxIncoming: 1,
        maxOutgoing: 1,
        maxOutgoingPerType: (_d = {},
            _d[NODE_NAMES.TIME_ROUTER] = Infinity,
            _d[NODE_NAMES.BUYER_ROUTER] = 1,
            _d[NODE_NAMES.BUYER] = 1,
            _d)
    },
    _a[NODE_NAMES.BUYER_ROUTER] = {
        // "Buyer Router Node"
        // Incoming from inbound phone call or AI agent
        // Outgoing to buyer node
        allowedIncomingNodes: [NODE_NAMES.INBOUND_CALL, NODE_NAMES.AI_AGENT, NODE_NAMES.TIME_ROUTER],
        allowedOutgoingNodes: [NODE_NAMES.BUYER, NODE_NAMES.TIME_ROUTER],
        maxOutgoing: Infinity,
        maxIncoming: Infinity,
        maxOutgoingPerType: (_e = {},
            _e[NODE_NAMES.TIME_ROUTER] = Infinity,
            _e[NODE_NAMES.BUYER] = Infinity,
            _e)
    },
    _a[NODE_NAMES.BUYER] = {
        // "Buyer Node"
        // Incoming from Buyer Router, or Agent Node (AiAgentNode)
        // No outgoing
        allowedIncomingNodes: [NODE_NAMES.BUYER_ROUTER, NODE_NAMES.AI_AGENT, NODE_NAMES.TIME_ROUTER],
        allowedOutgoingNodes: [],
        maxIncoming: Infinity,
        maxOutgoing: 0
    },
    _a[NODE_NAMES.TIME_ROUTER] = {
        // "Time Router Node"
        // Can connect to and from any node
        allowedIncomingNodes: [
            NODE_NAMES.INBOUND_CALL,
            NODE_NAMES.CALL_DISTRIBUTION_ROUTER,
            NODE_NAMES.AI_AGENT,
            NODE_NAMES.BUYER_ROUTER,
            NODE_NAMES.BUYER,
        ],
        allowedOutgoingNodes: [
            NODE_NAMES.CALL_DISTRIBUTION_ROUTER,
            NODE_NAMES.AI_AGENT,
            NODE_NAMES.BUYER_ROUTER,
            NODE_NAMES.BUYER,
        ],
        maxIncoming: Infinity,
        maxOutgoing: 1,
        maxOutgoingPerType: (_f = {},
            _f[NODE_NAMES.CALL_DISTRIBUTION_ROUTER] = 1,
            _f[NODE_NAMES.AI_AGENT] = 1,
            _f[NODE_NAMES.BUYER_ROUTER] = 1,
            _f[NODE_NAMES.BUYER] = 1,
            _f)
    },
    _a);
